import apiClient, { API_ENDPOINTS, rejectWithError, unwrapApiData } from "api";

const { certificate } = API_ENDPOINTS;

export const issueCertificate = async (certificatePayload) => {
  try {
    const data = await apiClient.post(certificate.issue, certificatePayload);
    return unwrapApiData(data);
  } catch (error) {
    return rejectWithError(error, "Error issuing certificate");
  }
};

export const findCertificatesByCriteria = async (criteria) => {
  try {
    const data = await apiClient.post(certificate.findByCriteria, criteria);
    return unwrapApiData(data);
  } catch (error) {
    return rejectWithError(error, "Error finding certificates");
  }
};

export const verifyCertificate = async (identifier) => {
  try {
    const data = await apiClient.get(certificate.verify, { pathParams: { identifier } });
    return unwrapApiData(data);
  } catch (error) {
    return rejectWithError(error);
  }
};
